import every from 'lodash/every';
import method from 'lodash/method';

export default class KeyboardListener {
   constructor(callback, keyCode, options) {
      this.callback = callback;
      this.keyCode = keyCode;
      this.options = options;
   }
   handle(ev) {
      if (this.options.ignoreInput && _isTextInput(ev.target) ) {
         return !ev.defaultPrevented;
      }

      let needHandle = !this.keyCode || (ev.keyCode || ev._keyCode) === this.keyCode;
      needHandle = needHandle && !ev.cancelBubble;
      needHandle = needHandle && every(this.options.manageKeys, method('isPressed', ev));
      if ( needHandle ) {
         if ( this.options.prevent ) {
            ev.preventDefault();
         }

         if (this.options.stop) {
            ev.stopPropagation();
            ev.stopImmediatePropagation();
         }

         if (this.options.shareEvent) {
            this.callback(ev);
         } else {
            this.callback();
         }

      }
      return !ev.defaultPrevented;
   }
}

function _isTextInput(target) {
   let res = false;

   res = res || target instanceof HTMLTextAreaElement;
   res = res || target instanceof HTMLInputElement && target.type === 'text';

   return res;
}
